import React from "react";
import { SortOrder } from "../../api/common/sortOrder";
import { TalentOrderByFieldKeys, TalentSummary } from "../../models/app/talent";
import contextPlaceholderFunc from "../../utils/contextPlaceholderFun";
import { ITEMS_PER_PAGE } from "../../api/common/pagination";

export type FindTalentContextType = {
    talents: TalentSummary[]
    isLoading: boolean
    searchTerm: string
    skillIds: string[]
    locationIds: string[]
    languageIds: string[]
    industrialExperienceIds: string[]
    sortOrder: SortOrder
    orderBy: TalentOrderByFieldKeys
    anyActiveFilters: boolean
    pageIndex: number
    pageSize: number
    totalCount: number
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    setSearchTerm: (value: string) => void
    setSkillIds: React.Dispatch<React.SetStateAction<string[]>>
    setLocationIds: React.Dispatch<React.SetStateAction<string[]>>
    setLanguageIds: React.Dispatch<React.SetStateAction<string[]>>
    setIndustrialExperienceIds: React.Dispatch<React.SetStateAction<string[]>>
    setSortOrder: (value: SortOrder) => void
    setOrderBy: (value: TalentOrderByFieldKeys) => void
    clearAllFilters: () => void
    searchNow: () => void
    setPageIndex: (pageIndex: number) => void
    setPageSize: (pageSize: number) => void
}

export const FindTalentContext = React.createContext<FindTalentContextType>({
    talents: [],
    isLoading: false,
    searchTerm: "",
    skillIds: [],
    locationIds: [],
    languageIds: [],
    industrialExperienceIds: [],
    sortOrder: "asc",
    orderBy: "LastName",
    anyActiveFilters: false,
    setSearchTerm: contextPlaceholderFunc,
    setSkillIds: contextPlaceholderFunc,
    setLocationIds: contextPlaceholderFunc,
    setLanguageIds: contextPlaceholderFunc,
    setIndustrialExperienceIds: contextPlaceholderFunc,
    setSortOrder: contextPlaceholderFunc,
    setOrderBy: contextPlaceholderFunc,
    clearAllFilters: contextPlaceholderFunc,
    searchNow: contextPlaceholderFunc,
    pageIndex: 0,
    pageSize: ITEMS_PER_PAGE,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
    setPageIndex: contextPlaceholderFunc,
    setPageSize: contextPlaceholderFunc,
});

export const useFindTalentContext: () => FindTalentContextType = () => React.useContext(FindTalentContext);
